import { $ } from '@utils';

function init() {
  if (!$('[data-au-menu-slide-down]')) return;

  addEventListeners();
}

function addEventListeners() {
  window.addEventListener('scroll', function () {
    const menu = $('[data-au-menu-slide-down]');
    const menuHeight = menu.offsetHeight;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > menuHeight) {
      menu.classList.add('au-menu-slide-down--slided');
    } else {
      menu.classList.remove('au-menu-slide-down--slided');
    }
  });
}

export default { init };
